import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import mixpanel from "mixpanel-browser";
import { operatorType, capchaKey,mixPanelToken, isStage} from "../../config";
import { message } from "antd";
import { Fetch } from "../../utils/fetch";
import "./login.scss";
import Otpinput from "../../components/OtpInput";
import styles from "./desktop.module.scss";
import jwt from "../../utils/jwt";
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: "",
      login: false,
      showOTP: false,
      isMobileDevice: false,
      showOtpError: false,
      showAttemptError: false,
      redirect: false,
      redirectUrl: "/",
    };

    this.recaptchaRef = React.createRef();
  }

  async componentDidMount() {
    const regex =
      /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const isMobile = regex.test(navigator.userAgent);
    localStorage.removeItem("idToken");
    localStorage.removeItem("consentGivenAt")
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userType");
    if (isMobile) {
      this.setState({ isMobileDevice: true });
    }

    // Retrieve the intended URL (if any) from sessionStorage
    const storedRedirectUrl = sessionStorage.getItem("redirectAfterLogin");
    if (storedRedirectUrl) {
      this.setState({ redirectUrl: storedRedirectUrl });
    }
  }

  handleChange = (key, value) => {
    this.setState({ [key]: value });
  };

  sendOtp = async () => {
    this.recaptchaRef.current.execute();
  };

  hideOtp = () => {
    this.setState({
      showOTP: false,
      showOtpError: false,
      showAttemptError: false,
    });
  };

  verifyOTP = async (data) => {
    const url = `/user/verifyOtp`;

    const options = {
      method: "post",
      data,
    };

    const response = await Fetch(url, options);
    if (response == "Invalid OTP") {
      this.setState({ showOtpError: true });
    } else if (response == "No Attempts Left, Contact Support") {
      this.setState({ showAttemptError: true });
    } else {
      const token = localStorage.getItem("idToken");
      const decodedToken = jwt.decode(token);
      let userType = decodedToken.electricId
        ? "electric"
        : decodedToken.userType;
      // if (sessionStorage.getItem("userType")) {
      //   userType = sessionStorage.getItem("userType");
      // }

      // Retrieve and clear the intended URL from sessionStorage

      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("Log in Successful", {
        view_from: "login page",
        mobile_number: this.state.phone,
        type: userType,
      });

      const redirectUrl =
        sessionStorage.getItem("redirectAfterLogin") ||
        (userType === operatorType.CABOWNER ? "/trips" : "/");
      sessionStorage.removeItem("redirectAfterLogin");

      this.setState({ redirect: true, userType: userType, redirectUrl });
    }
  };

  resendOtp = async () => {
    if (this.recaptchaRef.current) {
      this.recaptchaRef.current.execute();
    } else {
      message.error("ReCAPTCHA ref is not available.");
    }
  };

  handleCaptchaChange = async (value) => {
    if (value) {
      this.setState({ captchaValue: value });
    } else {
      message.error("ReCAPTCHA verification failed");
    }
    const { phone } = this.state;
    if (phone.length < 10) {
      return message.error("Mobile Number is required");
    }
    const options = {
      data: {
        mobileNo: phone,
        captchaValue: value,
      },
      method: "post",
    };

    const response = await Fetch("/user/login", options);

    if (response === "otp sent") {
      this.setState({ showOTP: true });
    } else {
      message.error("User Not Registered");
    }
  };

  render() {
    const {
      phone,
      showOTP,
      showOtpError,
      showAttemptError,
      redirect,
      isMobileDevice,
      redirectUrl,
    } = this.state;
    if (redirect) {
      return <Redirect to={redirectUrl} />;
    }
    if (isMobileDevice) {
      return (
        <div className="loginDiv">
          <div className="container">
            <div className="header">
              <img
                alt="logo"
                src="https://d1flzashw70bti.cloudfront.net/original/images/operator/login/logo/logo.svg"
              ></img>
            </div>
            <div className="login">
              <p className="textHeader">Login to Operator Dashboard</p>

              {showOTP ? (
                <Otpinput
                  isMobile={true}
                  number={phone}
                  resendOTP={this.resendOtp}
                  hideOtp={this.hideOtp}
                  showOtpError={showOtpError}
                  showAttemptError={showAttemptError}
                  verifyOTP={this.verifyOTP}
                />
              ) : (
                <>
                  <span className="textSubHeader">
                    Please enter your registered mobile number
                  </span>
                  <div className="mobileNumberInput">
                    <span>+91</span>
                    <div className="vl">
                      <input
                        type="text"
                        name="phoneNumber"
                        id="phoneNumber"
                        inputmode="numeric"
                        autoComplete="off"
                        pattern="\d*"
                        value={phone}
                        onChange={(e) => {
                          const re = /^[0-9\b]+$/;
                          if (
                            e.target.value.length < 11 &&
                            (e.target.value === "" || re.test(e.target.value))
                          ) {
                            this.handleChange("phone", e.target.value);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <button onClick={this.sendOtp}>Send OTP</button>
                </>
              )}
            </div>
          </div>
          <ReCAPTCHA
            ref={this.recaptchaRef}
            sitekey={capchaKey}
            onChange={this.handleCaptchaChange}
            size="invisible"
          />
        </div>
      );
    } else {
      return (
        <div className={styles.DesktopWrapper}>
          <div className={styles.background}></div>
          <div className={styles.detail}>
            <div className={styles.login}>
              <p className={styles.textHeader}>Welcome Operator </p>
              <p className={styles.textSubHeader}>Easy Login With Otp</p>
              {showOTP ? (
                <Otpinput
                  isMobile={false}
                  number={phone}
                  resendOTP={this.resendOtp}
                  hideOtp={this.hideOtp}
                  showOtpError={showOtpError}
                  showAttemptError={showAttemptError}
                  verifyOTP={this.verifyOTP}
                />
              ) : (
                <>
                  <p className={styles.textSubHeader}>
                    Enter Registered Number
                  </p>
                  <div className={styles.mobileNumberInput}>
                    <span>+91</span>
                    <div className="vl">
                      <input
                        type="text"
                        name="phoneNumber"
                        id="phoneNumber"
                        inputmode="numeric"
                        autoComplete="off"
                        pattern="\d*"
                        value={phone}
                        onChange={(e) => {
                          const re = /^[0-9\b]+$/;
                          if (
                            e.target.value.length < 11 &&
                            (e.target.value === "" || re.test(e.target.value))
                          ) {
                            this.handleChange("phone", e.target.value);
                          }
                        }}
                      />
                    </div>
                  </div>

                  <button onClick={this.sendOtp}>Send OTP</button>
                </>
              )}
            </div>
          </div>
          <ReCAPTCHA
            ref={this.recaptchaRef}
            sitekey={capchaKey}
            onChange={this.handleCaptchaChange}
            size="invisible"
          />
        </div>
      );
    }
  }
}

export default Login;
